import {createSelector} from 'reselect';


const timelineCommentsSelector = state => state.timelineComments;
const parentIdSelector = (_, props) => props.parentId;


export const timelineCommentByParentId = createSelector(
    timelineCommentsSelector,
    parentIdSelector,
    (Comment, key) => Comment[key] || Comment['default']
);

export const timelineCommentKeysByParentId = createSelector(
    timelineCommentsSelector,
    (Comment, parentId) => Object.values(Comment).filter((Comment) => Comment.parentId=== parentId)
);